import axios from 'axios';
import store from '../store'
import router from "../router";

class HelpDeskRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    // Asset related
    allAssetsOflUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/assets/user/${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    // Broker related
    allBrokerAccountsOfUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/broker-accounts/user/external?userId=${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    updateBrokerAccount(brokerAccount) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/broker-accounts`, brokerAccount, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    // Trade related
    createVerifiedTrade(trade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/validate`, trade, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    deleteTrade(tradeId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/trades/${tradeId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }


    // Tournament related
    getTournaments() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments`,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    getTournamentOverview(tournamentId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments/overview/${tournamentId}`,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    enrollParticipant(tournamentParticipant) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/tournament-participants`, tournamentParticipant,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    findParticipantByTournament(tournamentId, userId){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournament-participants?tournamentId=${tournamentId}&userId=${userId}`,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new HelpDeskRepository();
